var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Update Password")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit()
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Password Baru",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "password",
    attrs: {
      "type": "password",
      "placeholder": "New Password",
      "name": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('password')) + "\n                  ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Konfirmasi Password",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Konfirmasi Password",
      "name": "Konfirmasi Password"
    },
    model: {
      value: (_vm.confirm),
      callback: function($$v) {
        _vm.confirm = $$v
      },
      expression: "confirm"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Konfirmasi Password')),
      expression: "errors.has('Konfirmasi Password')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('Konfirmasi Password')) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('vue-button-spinner', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#20a8d8",
      "color": "white",
      "border-radius": "6px",
      "width": "150px"
    },
    attrs: {
      "is-loading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "type": "submit"
    }
  }, [_c('span', [_vm._v("Update Password")])])], 1)], 1)])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\icon.jpeg",
      "width": "100%"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e90014d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/UpdatePassword.vue
// module id = 176
// module chunks = 0